import { render, staticRenderFns } from "./ForwardDocumentsModal.vue?vue&type=template&id=20e2cfcd&scoped=true&"
import script from "./ForwardDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./ForwardDocumentsModal.vue?vue&type=script&lang=js&"
import style0 from "./ForwardDocumentsModal.vue?vue&type=style&index=0&id=20e2cfcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e2cfcd",
  null
  
)

export default component.exports